<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <header-page
        titleText="Gestão de Usuários"
        titleIcon="fal fa-users-cog"
      />
      <v-container pa-6>
        <v-row justify="space-between">
          <v-col cols="auto">
            <p class="list-labels">Lista de Usuários</p>
          </v-col>
          <v-skeleton-loader
            ref="skeleton"
            :boilerplate="false"
            type="table-tfoot"
            :tile="false"
            class="ml-auto"
            v-show="loading"
            min-width="300px"
          ></v-skeleton-loader>
          <v-col cols="auto" v-show="!loading">
            <v-container grid-list-md pa-0>
              <v-layout justify-start wrap justify-sm-end>
                <v-flex col-12 col-sm-6>
                  <!-- @keyup="addSearchTerm($event, false)"-->
                  <v-combobox
                    v-model="currentSearchTerm"
                    :loading="loading"
                    :items="items"
                    label="Buscar"
                    outlined
                    clearable
                    dense
                    @change="addSearchTerm($event, true)"        
                  ></v-combobox>
                </v-flex>
                <v-flex flex-grow-0 col-12 col-sm-4>
                  <v-select
                    v-model="selectedOrderBy"
                    :items="orderByOptions"
                    label="Ordenar por"
                    item-text="name"
                    item-value="id"
                    outlined
                    hide-details="auto"
                    dense
                    solo
                    flat
                    @change="loadUsers"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <!-- Search Results ########################################### -->
      <search-result
        inset
        :totalResults="totalNumberOfUsers"
        v-model="searchTerms"
        @itemRemoved="searchTermRemoved()"
        :addButtonDestiny="routes.app.UserRegisterNew"
      />

      <v-skeleton-loader
        ref="skeleton"
        :boilerplate="false"
        type="table-tbody"
        :tile="false"
        class="mx-auto"
        v-show="loading"
      ></v-skeleton-loader>

      <!-- Page Body ########################################### -->
      <v-container>
        <div>
          <template v-for="(userEntity, index) in userEntities">
            <v-divider v-if="index > 0" :key="'UserEntity' + index"></v-divider>
            <v-layout :key="userEntity.id" class="main-list-item" align-center>
              <!--avatar #########################-->
              <v-col cols="auto" class="flex-grow-0 pr-2 py-0">
                <v-avatar size="65">
                  <img
                    :src="
                      `https://ui-avatars.com/api/?name=${userEntity.personViewModel.fullName}&size=160`
                    "
                  />
                </v-avatar>
              </v-col>
              <!-- dados -->
              <v-col
                cols="12"
                md="6"
                lg="auto"
                class="pb-0 benfeitor flex-grow-1 flex-shrink-0"
                style="width:300px"
              >
                <v-flex pl-2 pt-sm-0 pt-12>
                  <div>
                    <v-chip small :color="GetColorByEntityType(userEntity.entityViewModel.entityType)">{{
                      GetEntityType(userEntity.entityViewModel.entityType)
                    }}</v-chip>
                    <span class="tiny-label ml-2">{{
                      userEntity.entityViewModel.name
                    }}</span>
                  </div>
                  <h4 class="font-weight-regular">
                    {{ userEntity.personViewModel.fullName }}
                    <span class="caption op-5">
                      ({{
                        userEntity.personViewModel.document | FormatDocument
                      }})</span
                    >
                  </h4>
                  <div class="op-5">
                    <em>{{ GetUserJobRole(userEntity.jobRoleId) }}</em>
                  </div>
                </v-flex>
              </v-col>

              <!-- tools #########################-->
              <div class="tools">
                <v-container fluid pa-0>
                  <v-row no-wrap align="center" no-gutters>
                    <!-- creation date  #########################-->
                    <v-col cols="auto">
                      <v-layout align-end column>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-flex>
                              <v-icon
                                color="var(--text)"
                                class="mr-2"
                                size="16"
                                v-on="on"
                                >fal fa-user-tag</v-icon
                              >
                              <span class="tiny-label">{{
                                GetUserAge(userEntity.personViewModel)
                              }}</span>
                            </v-flex>
                          </template>
                          <span
                            >Cadastrado em:
                            {{
                              userEntity.personViewModel.creationDate
                                | FormatDate
                            }}</span
                          >
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-flex>
                              <div :class="GetStatus(userEntity.userViewModel.lastLogin)" v-on="on"></div>
                            </v-flex>
                          </template>
                          <span 
                            >Último Login:
                            {{ userEntity.userViewModel.lastLogin | FormatDate }}</span
                          >
                        </v-tooltip>
                      </v-layout>
                    </v-col>

                    <v-col cols="auto" class="flex-grow-0 no-wrap">
                      <!-- user / admin & finances #########################-->
                      <v-layout>
                        <div class="profile-chip">
                          <v-tooltip top v-if="userEntity.admin">
                            <template v-slot:activator="{ on }">
                              <v-icon
                                size="20"
                                v-on="on"
                                class="mr-2"
                                color="var(--gray-light)"
                                >fal fa-user-crown</v-icon
                              >
                            </template>
                            <span>Administrador</span>
                          </v-tooltip>
                          <v-tooltip top v-if="userEntity.finance">
                            <template v-slot:activator="{ on }">
                              <v-icon
                                size="20"
                                v-on="on"
                                class="ml-2"
                                color="var(--accent)"
                                >fal fa-usd-square</v-icon
                              >
                            </template>
                            <span>Financeiro</span>
                          </v-tooltip>
                        </div>
                      </v-layout>
                    </v-col>

                    <!-- context menu - mobile #########################-->
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on"
                          color="var(--gray)"
                          class="ml-3 d-flex d-md-none"
                        >
                          <v-icon>far fa-ellipsis-v</v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item v-for="(item, i) in contextMenu" :key="i">
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <!-- edit & on/off #########################-->
                    <v-col cols="auto">
                      <v-layout
                        align-center
                        class="d-none d-md-flex flex-grow-0"
                      >
                        <v-flex pl-6>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                fab
                                small
                                color="var(--gray)"
                                class="hover-red"
                                v-on="on"
                                @click="editUser(userEntity)"
                              >
                                <v-icon size="20">fal fa-pen</v-icon>
                              </v-btn>
                            </template>
                            <span>Editar</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex pl-6>
                          <v-switch
                            v-model="userEntity.active"
                            @change="updateUserStatus(userEntity.id)"
                            inset
                          >
                          </v-switch>
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-layout>
          </template>
        </div>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import HeaderPage from "@/components/HeaderPage";
import SearchResult from "@/components/SearchResult";
import CommonHelper from "@/scripts/helpers/common.helper";
import UserOrderByOptions from "@/scripts/enums/userOrderByOptions.enum";
import AuthService from "@/scripts/services/auth.service";
import Routes from "@/router/names.js";
import EntityTypes from "@/scripts/enums/entityTypes.enum";
import JobRoles from "@/scripts/enums/jobRoles.enum";

export default {
  name: "UserManagement",
  components: {
    NavBar,
    HeaderPage,
    SearchResult
  },
  data: () => ({
    routes: Routes,
    authService: new AuthService(),
    page: 1,
    dialog: false,
    loadingCount: false,
    loadingList: false,
    totalNumberOfUsers: 0,
    userEntities: [],
    items: [],
    search: null,
    userEntititesNamesToSearch: [],
    searchTerms: [],
    currentSearchTerm: [],
    searchWaitTime: 2000,
    selectedOrderBy: UserOrderByOptions.Name,
    orderByOptions: [
      { id: UserOrderByOptions.CreationDate, name: "Ordenar por data" },
      { id: UserOrderByOptions.Name, name: "Ordenar por nome" },
      { id: UserOrderByOptions.Status, name: "Ordenar por status" }
    ],
    itemsSelectEnt: [
      "Ordenar por Benfeitores",
      "Ordenar por Conselho",
      "Ordenar por Instituição",
      "Ordenar por Secretaria"
    ],
    contextMenu: [
      { icon: "fal fa-pen", menu: "Editar" },
      { icon: "fal fa-ban", menu: "Desativar" }
    ]
  }),
  mounted() {
    this.loadUsers();
  },
  computed: {
    ...mapGetters("userModule", ["loggedEntityId", "isAdminOrBenefactor"]),
    loading() {
      return this.loadingList || this.loadingCount;
    }
  },
  methods: {
    ...mapActions(["setSelectedUser"]),
     querySelections (v) {
        this.items = this.userEntititesNamesToSearch.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
    },
    getFilters() {
      return {
        orderBy: this.selectedOrderBy,
        currentPage: this.currentPage - 1,
        pageSize: this.selectedPagination,
        searchTerms: this.searchTerms,
        loggedEntityId: parseInt(this.loggedEntityId)
      };
    },
    loadUsers() {
      if (this.loading) return;
      this.loadingCount = true;
      this.loadingList = true;
      this.searchTimeout = null;

      this.authService
        .countUsers(this.getFilters())
        .then(this.countUsersCallBack)
        .finally(() => (this.loadingCount = false));
      this.authService
        .listUsers(this.getFilters())
        .then(this.listUsersCallBack)
        .finally(() => (this.loadingCount = false));
    },
    countUsersCallBack(data) {
      this.totalNumberOfUsers = data;
      this.loadingCount = false;
    },
    listUsersCallBack(data) {
      this.userEntities = data;
      if(this.items.length == 0) {
        this.userEntities.forEach(element => {
          this.items.push(element.userViewModel.personViewModel.fullName);
        });
        this.item = this.items.sort();
      }
      this.loadingList = false;
    },
    addSearchTerm(event, addAnyway) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(this.loadUsers, this.searchWaitTime);
      }
      if (event.key == "Enter" || addAnyway) {
        if (
          this.currentSearchTerm &&
          this.currentSearchTerm.length > 0 &&
          this.searchTerms.indexOf(this.currentSearchTerm) == -1
        )
          this.searchTerms.push(this.currentSearchTerm);
        this.currentSearchTerm = [];
        if (!this.searchTimeout)
          this.searchTimeout = setTimeout(this.loadUsers, this.searchWaitTime);
      }
    },
    GetUserAge(entity) {
      return CommonHelper.GetEntityAge(entity);
    },
    editUser(userEntity) {
      this.setSelectedUser(userEntity);
      this.$router.push({
        name: Routes.app.UserRegister,
        params: { userId: userEntity.userViewModel.id }
      });
    },
    updateUserStatus(userEntityId) {
      this.authService
        .updateUserStatus(userEntityId);
    },
    GetEntityType(entityTypeId) {
      if (entityTypeId == EntityTypes.Council) {
        return "Conselho";
      } else if (entityTypeId == EntityTypes.Institution) {
        return "Instituição";
      } else if (entityTypeId == EntityTypes.Secretary) {
        return "Secretaria";
      } else if (entityTypeId == EntityTypes.Benefactor) {
        return "Benfeitores";
      }
    },
    GetColorByEntityType(entityTypeId){
      if (entityTypeId == EntityTypes.Council) {
        return "primary";
      } else if (entityTypeId == EntityTypes.Institution) {
        return "success";
      } else if (entityTypeId == EntityTypes.Secretary) {
        return "secondary";
      } else if (entityTypeId == EntityTypes.Benefactor) {
        return "Benfeitores";
      }
    },
    GetUserJobRole(jobRoleId) {
      if (jobRoleId == JobRoles.President) {
        return "Presidente";
      } else if (jobRoleId == JobRoles.Representative) {
        return "Representante";
      } else if (jobRoleId == JobRoles.Others) {
        return "Outros";
      }
    },
    searchTermRemoved() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.loadUsers, this.searchWaitTime);
    },
    GetStatus(lastLogin) {
      if(!lastLogin){
        return "login-status never";
      }

      let lastLoginDateDayOfTheMonth = new Date(lastLogin).getDate();

      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0');

      var lastLoginNUmberOfDays = dd - lastLoginDateDayOfTheMonth;

      if(lastLoginNUmberOfDays == 0){
        return "login-status ok";
      } else if(lastLoginNUmberOfDays == 1) {
        return "login-status _24h";
      } else if (lastLoginNUmberOfDays >=  2){
        return "login-status _48h";
      }
    },
  }
};
</script>